import { state } from './state';
import { loadFullResolutionImage } from './images';
//import { loadVideo, stopVideo } from './video';
//import { createVideoToggle } from './videoToggle';

/**
 * Updates the active production item and associated UI elements.
 */
export function setActiveItem(item, forceUpdate) {
  const activeIdx = state.productionItems.indexOf(item);
  console.log(state.activeItemIndex,  activeIdx, "activeItel", item)
  if (forceUpdate!==true && state.activeItemIndex === activeIdx) {
    return;
  }

  // Remove active classes and aria-current attributes
  state.productionItems.forEach(i => {
    i.classList.remove('active');
    i.removeAttribute('aria-current');
  });

  // Set active item
  item.classList.add('active');
  item.setAttribute('aria-current', 'true');
  state.activeItemIndex = activeIdx;

  // Play current sprite

  const spriteIdx = state.activeItemIndex % state.sprites.length;
  const currentSpriteContainer = document.getElementById("archive_production-placeholder-sprite-" + spriteIdx);
  if (currentSpriteContainer) {
    const currentItem = state.productionItems[state.activeItemIndex];
    if (currentItem) {
      const spriteDock = currentItem.querySelector('.homepage-sprite');
      spriteDock.appendChild(currentSpriteContainer);
      currentSpriteContainer.style.display="block";

      const currentSpriteElement = currentSpriteContainer.querySelector('.sprite');
      const currentSprite = window.spriteAnimations.find(
        ({ container }) => container === currentSpriteElement,
      );

      if (currentSprite) {
        currentSprite.controls.play();
      } else {
        console.log("sprite not found");
      }
    } else {
      console.log("current item " + state.activeItemIndex + " not found")
    }
  } else {
    console.log(".archive_production-placeholder-sprite-" + spriteIdx+" not found");
  }

  // Manage preload image and full-res picture
  const img = archive_images[state.activeItemIndex];
  const preloadImg = state.preloadImages[state.onPreloadImage];
  const fullPicture = state.fullResPictures[state.onPreloadImage];
  state.onPreloadImage = (state.onPreloadImage+1) % state.preloadImages.length
  const preloadImgOld = state.preloadImages[state.onPreloadImage];
  const fullPictureOld = state.fullResPictures[state.onPreloadImage];
  
  state.mobileVideo = img['data-trailer-mobile'];
  state.desktopVideo = img['data-trailer-desktop'];
  const hasVideo = state.mobileVideo || state.desktopVideo;


//  state.preloadImages.forEach((img, index) => {
//    img.style.opacity = index === state.activeItemIndex ? 1 : 0;
//  });

  loadFullResolutionImage(fullPicture, fullPictureOld, preloadImg, preloadImgOld, img);


  setTimeout(()=>{
    window.preloadImageCache=[];
    archive_images.forEach(img=>{
      const i = document.createElement("img");
      i.src=img['preload_image'];
      window.preloadImageCache.push(i);
    });
  }, 500);

//  state.fullResPictures.forEach((picture, index) => {
//    picture.style.zIndex = index === state.activeItemIndex ? 2 : 1;
//    picture.style.opacity = index === state.activeItemIndex ? 1 : 0;
//    if (index === state.activeItemIndex)
//      loadFullResolutionImage(picture, preloadImg);
//  });
/*
  if (hasVideo) {
    loadVideo(state.mobileVideo, state.desktopVideo);
  } else {
    stopVideo(document.getElementById('videoPlayer'));
  }
*/
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    if (hasVideo) {
//      if (!state.toggleButton) createVideoToggle();
    } else {
      if (state.toggleButton) {
        state.toggleButton.remove();
        state.toggleButton = null;
      }
    }
  }

  state.lastActiveItemIndex = state.activeItemIndex;
}

/**
 * Finds the production item closest to the top of the container.
 */
export function getItemAtActivePosition() {
  const ulTop = state.productionList.getBoundingClientRect().top;
  const paddingTop = parseFloat(
    window.getComputedStyle(state.productionList).paddingTop,
  );
  const referenceY = ulTop + paddingTop;

  let closest = null;
  let minDist = Infinity;

  state.productionItems.forEach(item => {
    const rect = item.getBoundingClientRect();
    const distance = Math.abs(rect.top + rect.height / 2 - referenceY);
    if (distance < minDist) {
      closest = item;
      minDist = distance;
    }
  });

  return closest;
}

/**
 * Updates the active item based on scroll position.
 */
export function updateActiveItem() {
  const item = getItemAtActivePosition();
  if (item) setActiveItem(item);
}
